import { createStyles, makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) =>
  createStyles({
    input: {
      borderRadius: 8,
      background: ({ error }) => (error ? '#fff' : '#eceff1'),
      border: ({ error }) =>
        error ? `1px solid #f44336` : '1px solid #eceff1',
      transition: 'all 0.5s',
      '&:hover': {
        boxShadow: ({ error }) => (error ? 'none' : '0px 0px 4px #00BB42'),
        background: '#fff'
      }
    },
    focused: {
      borderColor: theme.palette.secondary.light,
      boxShadow: ({ error }) => (error ? 'none' : '0px 0px 4px #00BB42'),
      backgroundColor: '#fff !important'
    },
    label: {
      '&$focusedLabel': {
        color: '#546E7A'
      }
    },
    focusedLabel: {}
  })
)

export default useStyles
